'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TypeListComponent } from './component';
import { LKIcon } from '../icon/module';
import { LKTruncation } from '../truncation/module';

@NgModule({
  imports     : [
    BrowserModule,
    LKIcon,
    LKTruncation
  ],
  declarations: [TypeListComponent],
  exports     : [TypeListComponent]
})
export class LKTypeList {
}
